const updateMembersWorkoutsSelectedCategories = (state, { payload }) => {
	state.membersWorkoutsSelectedCategories = payload;
};

export default updateMembersWorkoutsSelectedCategories;
